module.exports = __webpack_public_path__ + "static/media/truck-tracking-btn.16c30d52.svg";